import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgProgressModule } from 'ngx-progressbar';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { webAppRoutes } from '../../utils/web.app.routes';
import { commonModules } from '../../utils/module-imports';
import { commonProviders } from '../../utils/provider-imports';
import { WebAppComponent } from './web-app.component';
import { WebHttpInterceptor } from '../../services/http-interceptors/web-interceptor/web-http-interceptor';
import { AuthService } from '../../modules/auth/services/auth.service';
import { WebAuthContextService } from '../../modules/auth/web-auth/services/web-auth-context.service';
import { WebAuthorizedLayoutModule } from '../../modules/common/web-authorized-layout/web-authorized-layout.module';
import { FileDownloadService } from '../../services/file-download-service/file-download.service';
import { WebFileDownloadService } from '../../services/file-download-service/web-file-download-service/web-file-download.service';
import { SqliteService } from '../../services/sqlite-service/sqlite.service';
import { Device } from '@ionic-native/device/ngx';
import { Camera } from '@ionic-native/camera/ngx';
import { FirebaseAnalyticsService } from 'firebase-analytics';
import { WebFirebaseAnalyticsService } from 'firebase-analytics';
import { firebaseConfig } from '../../utils/firebase-config';
import { RateService } from 'rate';
import { AlertPopupModule } from 'alert-popup';

export function WebFirebaseAnalyticsServiceFactory() {
  return new WebFirebaseAnalyticsService(firebaseConfig);
}
export function showRate() { }

@NgModule({
  declarations: [
    WebAppComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    CommonModule,
    NgProgressModule.withConfig({
      trickleSpeed: 200,
      min: 20,
      meteor: false
    }),
    RouterModule.forRoot(
      webAppRoutes,
      {
        enableTracing: false,
        useHash: true,
        onSameUrlNavigation: 'reload',
        scrollPositionRestoration: 'enabled'
      }
    ),
    WebAuthorizedLayoutModule,
    AlertPopupModule,
    ...commonModules
  ],
  providers: [
    ...commonProviders,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WebHttpInterceptor,
      multi: true
    },
    { provide: AuthService, useClass: WebAuthContextService },
    { provide: FileDownloadService, useClass: WebFileDownloadService },
    { provide: SqliteService, useValue: { sqlAvailable: false } },
    { provide: Device, useValue: { platform: 'Browser' } },
    { provide: RateService, useValue: { showRate: showRate } },
    { provide: FirebaseAnalyticsService, useFactory: WebFirebaseAnalyticsServiceFactory },
    { provide: Camera, useValue: { camera: null } }
  ],
  bootstrap: [WebAppComponent]
})
export class WebAppModule { }
